var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#006",
    d: "M0 0h53.3v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0h26.7v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m3.1 0 10.2 7.5L23.4 0h3.3v2.6l-10 7.4 10 7.5V20h-3.4l-10-7.5-10 7.5H0v-2.5l10-7.4L0 2.7V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "m17.7 11.7 9 6.6V20l-11.3-8.3zm-7.7.8.3 1.5-8 6H0zM26.7 0v.1L16.3 8V6l8.4-6zM0 0l10 7.3H7.5L0 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 0v20h6.7V0zM0 6.7v6.6h26.7V6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M0 8v4h26.7V8zm11.4-8v20h4V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M46.3 15.2v6.7c0 6-2.8 8-6.5 9.5-3.7-1.6-6.5-3.6-6.5-9.5v-6.8h13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcea83",
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M29.2 30.9c.2.5 1.7 1.3 3.5.3q1.7-.9 2.6-3.2.5-.8-.1-1.3l-1.3-.9-.4-.3.2.2c.7.9 0 2-.8 2.8-.6.5-1.6 1.8-3 .6-.3-.3-1 .9-.7 1.8Zm21.2 0c-.3.5-1.8 1.3-3.5.3q-1.7-.9-2.7-3.2-.4-.8.2-1.3l1.3-.9.4-.3-.2.2c-.7.9 0 2 .7 2.8.6.5 1.6 1.8 3.1.6.3-.3 1 .9.7 1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcea83",
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M39.8 33.9c2.8 0 7-1.3 9.4-5.7q.3-1-.5-1.3l-1.4-1q.8.7 0 1.5a8 8 0 0 1-7.5 4.5 8 8 0 0 1-7.6-4.5q-.7-.8 0-1.5-.5.6-1.4 1c-.4.2-.8.6-.4 1.3 2.3 4.4 6.6 5.7 9.4 5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M33.4 28c-.1-.4-.6-.2-.7.2l-.5-.8q-.7-.8.1-1.6.5-.6 1.2-.2c.8.6.4 1.7-.1 2.4Zm12.8 0c0-.4.6-.2.7.2l.5-.8q.7-.8-.2-1.6-.5-.6-1.2-.2c-.7.6-.4 1.7.2 2.4Zm-17 2.9c-.3-.5-.6-2-.7-2.2q-.2-.6.3-.8.5 0 .9.8l.7 1.8c-.7-.5-1.4-.1-1.2.4Zm21.2 0c.3-.5.6-2 .7-2.2q.2-.6-.3-.8-.6 0-.9.8l-.7 1.8q1.2-.6 1.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M37.1 15.1q-.5.3-1.2-.2-.3-.6.1-1 .4-.3 1-.2c.4 0 1.4 1 1.1 1zm1-1.7.9-.2q.6 0 .8.3.1.7.5 1c-.2.2-1 .3-1.3 0-.5-.1-.6-1-.8-1Zm3 0h.8q.7-.1.8.4 0 .6.2 1.1c-.2 0-1 0-1.2-.2-.3-.2-.3-1-.5-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#073163",
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M43.3 13.7h-.7c.2.2 0 1 .4 1.3.2.2.9.2 1-.2q.5-.6-.7-1.1Zm-3.6-.4.7-.1q.7 0 .9.3 0 .6.3 1.1c0 .2-1 .2-1.3 0zm-3 .3q0-.2 1-.2.6-.1.8.4 0 .6.5.8-1 .4-1.4 0-.5-.2-.8-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#059334",
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "m36.8 10.6-.6-.3c-.2-.3-.9-.5-1.2-.2l-.3.1q-.4 0-.3.5h.2v.1q.2.5.8.5l.6.2.1.3q.2 0 0 .3a1 1 0 0 0 0 1c.5.4 1.6.9 2.9-.1s3.2-.4 3.3 0l.3.6q0 .3.5.3l.6.2q.3.1.4-.2c-.2-1-.8-1.2-.8-1.6l.7-.1.4-.5h-.6c-1.6-.2-6.1-1.4-7-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "m43.9 11.7-.7.7q-.6.9-2.6 1-1.8 0-2.6-.7l-.8-.5q-.5-.4-.3-.9-.1.4-.4.3-.4 0-.4.2v-.2l-.1-.1.5-.1q.3 0 .3-.4l-.1-.4c.3-.2 4 .5 4.7.5s2.8.4 2.5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#059334",
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M37.3 10.4q.4-.5 1.2-.4.6-.3 1 0h.2c.4-.2 1.2 0 1.5.2q1.4 0 2.2 1 .1.3.4.3t0 .3l-.7.6q-.6.8-2.5.9t-2.6-.7l-.7-.4q-.4-.2-.4-.7.1-.3-.2-1h.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00493d",
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M43.4 11.3q-.8-1-2.1-1v.2q1 .4 1.7 1.3zm-2.2-1c-.3-.4-1.1-.5-1.5-.4v.5l.6.6.6-.2zm-1.6-.4q-.6-.1-1 .1l-.1.6.4.1.6-.3V10Zm-2.3.5q.4-.5 1.2-.4l-.1.5-1.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00493d",
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M42.8 11.8q-.6-.7-1.6-1.2v.3l.7 1.4zm-2.6.8v-1.4l.7-.2.8 1.4zM39 11l.5-.3q.4.1.6.5l-.2 1.5-1-.2zm-1.8.5V11q.7-.3 1.6 0v1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "m35.5 10.7-.3-.2h-.1v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M35.5 11.3c.4 0 .5-.5.7-.5m-.5.6c.3.1.6-.6.8-.6m-1.4-.3h.6m0 .5-.6.3m0-1.2q-.2 0-.3.3m-.1.2v.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M38.4 10.1Q37.3 9.2 36 9l2.4 1.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M38.4 10.1Q37.3 9.2 36 9l2.4 1.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M38.8 9.6A6 6 0 0 0 36 8.3a9 9 0 0 1 2.4 2m1.5-1.7q.6-1.4 1.7-2.3L40.7 9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M38.8 9.6A6 6 0 0 0 36 8.3a9 9 0 0 1 2.4 2m1.5-1.7q.6-1.4 1.7-2.3L40.7 9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M40.7 8.4q.5-1.2 1.8-1.8-.9 1.1-1.3 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M40.7 8.4q.5-1.2 1.8-1.8-.9 1.1-1.3 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41 9.1q1-1.5 2.8-2.3a18 18 0 0 0-2.5 3.1m.2 0c.6-.4 1.9-1 2.8-.7-.6.2-2.2 1-3 1.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M41 9.1q1-1.5 2.8-2.3a18 18 0 0 0-2.5 3.1m.2 0c.6-.4 1.9-1 2.8-.7-.6.2-2.2 1-3 1.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.4 9.6c.5-.6 1.6-1.5 2.8-1.9l-2.9 2.9m-1.6-1.3q-.5-2.1-2-3Q39 8 39.2 10m-.3-.7q-1-1.4-2.7-1.8 1.6 1.1 2.4 2.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M41.4 9.6c.5-.6 1.6-1.5 2.8-1.9l-2.9 2.9m-1.6-1.3q-.5-2.1-2-3Q39 8 39.2 10m-.3-.7q-1-1.4-2.7-1.8 1.6 1.1 2.4 2.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M39.3 9.2c-.9-1.6-1.6-1.8-2-2.2l1.7 3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M39.3 9.2c-.9-1.6-1.6-1.8-2-2.2l1.7 3m-1.5-.9q.8.4 1.3 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m37.5 9.8 1 .7Zm4.2.5q.6-.5 1.5-.8Zm-.3-.2 1.3-1.3Zm1-2.2-1.3 1.7Zm-.9-.3-.9 1.6Zm-2.8.1.8 1.9Zm-.3.6.6 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "m37.5 9.8 1 .7m3.2-.2q.6-.5 1.5-.8m-1.8.6 1.3-1.3m-.3-.9-1.3 1.7m.4-2-.9 1.6m-1.9-1.5.8 1.9m-1-1.3.5 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M39.6 8.1q0-.5.4-.6.5.2.5.6-.1.5-.5.5-.3 0-.4-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M39.2 8.4q0-.5.5-.6c.2 0 .3.5.2.7q0 .5-.4.5t-.3-.6Zm.9.1q0-.6.3-.7.4 0 .4.6.1.5-.2.6t-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M39.6 8.8q0-.6.4-.7.4.1.4.7t-.4.5-.4-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M39 9q0-.7.4-.7.4.1.4.7 0 .4-.4.5T39 9Zm1.2-.2q.1-.5.5-.6.4.2.4.6 0 .5-.4.5t-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M40.1 9.1q.1-.7.5-.7.3.1.4.7 0 .5-.4.5t-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M39.6 9.4q0-.6.4-.7c.2 0 .4.5.4.7q0 .5-.4.5t-.5-.5Zm-1 0q.1-.6.4-.7c.2 0 .3.5.3.7q0 .5-.3.5t-.3-.5Zm2 0q0-.7.4-.7.3.2.3.6 0 .5-.3.6t-.4-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M40.8 10q.2-.7.5-.7v.7q0 .5-.3.5t-.2-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M40.2 9.8q0-.5.4-.6.3.1.3.7t-.4.5-.3-.6Zm-1 .1q-.2-.6-.5-.5v.7q0 .3.4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M39 9.9q0-.6.3-.7.4.1.4.7t-.4.5-.3-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M39.5 10q0-.6.4-.7.4.1.4.7t-.4.5-.4-.5Zm.2-3.8q-.3.3-.2.9-.5-.2-.8.1.5 0 .7.3-.4 0-.5.3.4-.2.6-.1l-.3.4.6-.3q-.1.4.3.8v-.8c.4 0 .4.4.8.4q-.1-.3-.4-.5h.5l-.4-.3.6-.5q-.6 0-.8.3l.6-.9q-.4 0-.7.4 0-.4.2-.6l-.7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M39.8 6.7v.4Zm.5 0-.2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M39.8 6.7v.4m.5-.4-.2.5m.4-.1-.3.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcea83",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M29.2 30.9c.2.5 1.7 1.3 3.5.3q1.7-.9 2.6-3.2.5-.8-.1-1.3l-1.3-.9-.4-.3.2.2c.7.9 0 2-.8 2.8-.6.5-1.6 1.8-3 .6-.3-.3-1 .9-.7 1.8Zm21.2 0c-.3.5-1.8 1.3-3.5.3q-1.7-.9-2.7-3.2-.4-.8.2-1.3l1.3-.9.4-.3-.2.2c-.7.9 0 2 .7 2.8.6.5 1.6 1.8 3.1.6.3-.3 1 .9.7 1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcea83",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M39.8 33.9c2.8 0 7-1.3 9.4-5.7q.3-1-.5-1.3l-1.4-1q.8.7 0 1.5a8 8 0 0 1-7.5 4.5 8 8 0 0 1-7.6-4.5q-.7-.8 0-1.5-.5.6-1.4 1c-.4.2-.8.6-.4 1.3 2.3 4.4 6.6 5.7 9.4 5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M33.4 28c-.1-.4-.6-.2-.7.2l-.5-.8q-.7-.8.1-1.6.5-.6 1.2-.2c.8.6.4 1.7-.1 2.4Zm12.8 0c0-.4.6-.2.7.2l.5-.8q.7-.8-.2-1.6-.5-.6-1.2-.2c-.7.6-.4 1.7.2 2.4Zm-17 2.9c-.3-.5-.6-2-.7-2.2q-.2-.6.3-.8.5 0 .9.8l.7 1.8c-.7-.5-1.4-.1-1.2.4Zm21.2 0c.3-.5.6-2 .7-2.2q.2-.6-.3-.8-.6 0-.9.8l-.7 1.8q1.2-.6 1.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00493d",
    d: "m31.2 27.7-.2.2-.1.1-.2-.3h.1l.6-.3q.2 0 0 0l.1-.1.2.3h-.2zv.2l.4-.1v-.2l.2.3h-.2l-.6.3v.1l-.2-.3h.2l.2-.1zm.6.5q.2 0 0-.1l.4.5-.2.2.1-.4h-.2l-.2.1q0 .2.2 0l-.3.4q.1-.3 0-.4l-.2.2v.2h.3v.1l-.2.1-.4-.6h.2zm.6 1.3-.3.2v.2l-.2-.3h.1l.5-.5V29l.3.3h-.2zl.2.2.2-.2v-.2l.3.3h-.2l-.4.4q-.2.1 0 .2l-.3-.3h.1l.3-.2zm.5.8h.1l.1-.3-.2.2m0 0h-.2v.1l-.2-.1h.2l.7-.4-.4.7v.2l-.2-.2h.1zm.3.6h.2l.4-.6h-.3l.1-.2.6.4-.2.2v-.2l-.5.5v.2zm.8.2v.5l-.4-.2h.2l.4-.6v-.1l.2.1-.1.1-.2.3h.2l.2-.2v-.1l.3.2h-.2l-.3.6v.1l-.3-.2h.1l.2-.3zm.8 1h.2l.2-.6v-.1l.6.2-.2.3v-.3h-.1l-.2.2q0 .1.2 0l-.2.4v-.3l-.2.3v.1zm1 .6V32q0-.4.3-.4v.5q0 .4-.3.4.3 0 .5-.3 0-.4-.2-.6-.3 0-.5.3 0 .4.2.6m1 0 .2-.4V32h.1v.1zq0 .3-.4.3-.2 0-.1-.4l.1-.5v.1h.3v.1h-.1l-.2.5v.3q.3 0 .4-.2m.4-.4h.2l.2.6.1-.4v-.1h.2l-.2.1-.1.8-.3-.9-.2.6v.1H37l.1-.1zm1.2.7q-.1.4-.3.3v-.7h.2v.4zq0-.5-.3-.5l-.3-.1v.8l-.2.1h.3q.3.1.5-.3m.3-.3-.1-.1h.6v.3q0-.3-.2-.2v.3l.1-.2v.5q0-.2-.2-.2v.3q.3 0 .4-.2v.3h-.7l.1-.2zm1.1.4q0 .4-.2.4v-.8q.2-.1.2.4h.2q0-.4-.4-.4h-.3v.8h.3q.3.1.4-.4zm1 .3-.3.1v-.8h-.1l.3-.1zm.4 0v-.8H41l-.1.2-.1-.2.6-.1v.2q0-.2-.2-.2l.1.8h.1v.1zm1.5-.6-.2-.5.1-.1v.1zl-.2.4q-.2 0-.3-.3l-.1-.4-.2-.1.4-.1v.6l.3.2zm.4-.3v-.3L43 32zm0 0v.3q.2.1.2 0l-.3.2v-.1l-.2-.6-.2-.1.4-.2q.2 0 .3.2zm.8 0q-.3 0-.4-.3v-.5l.3.3zq.3-.1.2-.5-.2-.5-.5-.3a.4.4 0 0 0-.2.5q.2.4.5.3m0-1 .2-.1.6.3-.2-.3-.1-.1.2-.1v.1l.3.7-.8-.4.3.6h.1l-.1.1v-.1l-.3-.6zm1.5.1v-.1l-.4-.6v.3l-.2-.3.5-.3.2.2h-.3l.4.6h.1zm.6-.8.1.3h.2l-.3.2v-.1l-.4-.6h-.2l.3-.2v.1l.2.2.2-.1-.2-.2h-.1l.3-.3v.2l.4.5h.1l-.3.3v-.2l-.2-.3zm.2-.7h-.1l.4-.5.3.2h-.4v.2l.2.2v-.3l.3.3h-.3l.2.2v.1l.2-.1V30l.2.3-.5.4v-.1zm.9-1v.1h.6v.5l-.1.1-.3-.2q.4.2.4 0v-.2H47zV29q.1 0 0-.1l.3.2zm.3-.3h-.2l.4-.5.2.2h-.3v.1l.2.3v-.3l.3.3h-.2l.2.2h.1V29q.2 0 0-.3l.2.2-.3.5-.1-.2zm1-.6-.2.2-.2-.3zm0 0q.2 0 0 .2h.1l.2-.3h-.2l-.8-.2.6.7v.1l.1-.2h-.2zm-.3-.8v.2l.3-.1h.4q.2 0 .1.3l-.1.1h-.3q.3 0 .4-.2l-.1-.1h-.2q-.2.2-.4.1-.2 0-.1-.3v-.2l.3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M37.1 15.1q-.5.3-1.2-.2-.3-.6.1-1 .4-.3 1-.2c.4 0 1.4 1 1.1 1zm1-1.7.9-.2q.6 0 .8.3.1.7.5 1c-.2.2-1 .3-1.3 0-.5-.1-.6-1-.8-1Zm3 0h.8q.7-.1.8.4 0 .6.2 1.1c-.2 0-1 0-1.2-.2-.3-.2-.3-1-.5-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#073163",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M43.3 13.7h-.7c.2.2 0 1 .4 1.3.2.2.9.2 1-.2q.5-.6-.7-1.1Zm-3.6-.4.7-.1q.7 0 .9.3 0 .6.3 1.1c0 .2-1 .2-1.3 0zm-3 .3q0-.2 1-.2.6-.1.8.4 0 .6.5.8-1 .4-1.4 0-.5-.2-.8-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9d050",
    d: "M38.4 10.1Q37.3 9.2 36 9l2.4 1.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M38.4 10.1Q37.3 9.2 36 9l2.4 1.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9d050",
    d: "M38.8 9.6A6 6 0 0 0 36 8.3a9 9 0 0 1 2.4 2m1.5-1.7q.6-1.4 1.7-2.3L40.7 9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M38.8 9.6A6 6 0 0 0 36 8.3a9 9 0 0 1 2.4 2m1.5-1.7q.6-1.4 1.7-2.3L40.7 9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9d050",
    d: "M40.7 8.4q.5-1.2 1.8-1.8-.9 1.1-1.3 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M40.7 8.4q.5-1.2 1.8-1.8-.9 1.1-1.3 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9d050",
    d: "M41 9.1q1-1.5 2.8-2.3a18 18 0 0 0-2.5 3.1m.2 0c.6-.4 1.9-1 2.8-.7-.6.2-2.2 1-3 1.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M41 9.1q1-1.5 2.8-2.3a18 18 0 0 0-2.5 3.1m.2 0c.6-.4 1.9-1 2.8-.7-.6.2-2.2 1-3 1.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9d050",
    d: "M41.4 9.6c.5-.6 1.6-1.5 2.8-1.9l-2.9 2.9m-1.6-1.3q-.5-2.1-2-3Q39 8 39.2 10m-.3-.7q-1-1.4-2.7-1.8 1.6 1.1 2.4 2.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M41.4 9.6c.5-.6 1.6-1.5 2.8-1.9l-2.9 2.9m-1.6-1.3q-.5-2.1-2-3Q39 8 39.2 10m-.3-.7q-1-1.4-2.7-1.8 1.6 1.1 2.4 2.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9d050",
    d: "M39.3 9.2c-.9-1.6-1.6-1.8-2-2.2l1.7 3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M39.3 9.2c-.9-1.6-1.6-1.8-2-2.2l1.7 3m-1.5-.9q.8.4 1.3 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9d050",
    d: "m37.5 9.8 1 .7Zm4.2.5q.6-.5 1.5-.8Zm-.3-.2 1.3-1.3Zm1-2.2-1.3 1.7Zm-.9-.3-.9 1.6Zm-2.8.1.8 1.9Zm-.3.6.6 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m37.5 9.8 1 .7m3.2-.2q.6-.5 1.5-.8m-1.8.6 1.3-1.3m-.3-.9-1.3 1.7m.4-2-.9 1.6m-1.9-1.5.8 1.9m-1-1.3.5 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9d050",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M39.6 8.1q0-.5.4-.6.5.2.5.6-.1.5-.5.5-.3 0-.4-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9d050",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M39.2 8.4q0-.5.5-.6c.2 0 .3.5.2.7q0 .5-.4.5t-.3-.6Zm.9.1q0-.6.3-.7.4 0 .4.6.1.5-.2.6t-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9d050",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M39.6 8.8q0-.6.4-.7.4.1.4.7t-.4.5-.4-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9d050",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M39 9q0-.7.4-.7.4.1.4.7 0 .4-.4.5T39 9Zm1.2-.2q.1-.5.5-.6.4.2.4.6 0 .5-.4.5t-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9d050",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M40.1 9.1q.1-.7.5-.7.3.1.4.7 0 .5-.4.5t-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9d050",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M39.6 9.4q0-.6.4-.7c.2 0 .4.5.4.7q0 .5-.4.5t-.5-.5Zm-1 0q.1-.6.4-.7c.2 0 .3.5.3.7q0 .5-.3.5t-.3-.5Zm2 0q0-.7.4-.7.3.2.3.6 0 .5-.3.6t-.4-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9d050",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M40.8 10q.2-.7.5-.7v.7q0 .5-.3.5t-.2-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9d050",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M40.2 9.8q0-.5.4-.6.3.1.3.7t-.4.5-.3-.6Zm-1 .1q-.2-.6-.5-.5v.7q0 .3.4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9d050",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M39 9.9q0-.6.3-.7.4.1.4.7t-.4.5-.3-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9d050",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M39.5 10q0-.6.4-.7.4.1.4.7t-.4.5-.4-.5Zm.2-3.8q-.3.3-.2.9-.5-.2-.8.1.5 0 .7.3-.4 0-.5.3.4-.2.6-.1l-.3.4.6-.3q-.1.4.3.8v-.8c.4 0 .4.4.8.4q-.1-.3-.4-.5h.5l-.4-.3.6-.5q-.6 0-.8.3l.6-.9q-.4 0-.7.4 0-.4.2-.6l-.7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9d050",
    d: "M39.8 6.7v.4Zm.5 0-.2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M39.8 6.7v.4m.5-.4-.2.5m.4-.1-.3.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#059334",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "m36.8 10.6-.6-.3c-.2-.3-.9-.5-1.2-.2l-.3.1q-.4 0-.3.5h.2v.1q.2.5.8.5l.6.2.1.3q.2 0 0 .3a1 1 0 0 0 0 1c.5.4 1.6.9 2.9-.1s3.2-.4 3.3 0l.3.6q0 .3.5.3l.6.2q.3.1.4-.2c-.2-1-.8-1.2-.8-1.6l.7-.1.4-.5h-.6c-1.6-.2-6.1-1.4-7-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "m43.9 11.7-.7.7q-.6.9-2.6 1-1.8 0-2.6-.7l-.8-.5q-.5-.4-.3-.9-.1.4-.4.3-.4 0-.4.2v-.2l-.1-.1.5-.1q.3 0 .3-.4l-.1-.4c.3-.2 4 .5 4.7.5s2.8.4 2.5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#059334",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M37.3 10.4q.4-.5 1.2-.4.6-.3 1 0h.2c.4-.2 1.2 0 1.5.2q1.4 0 2.2 1 .1.3.4.3t0 .3l-.7.6q-.6.8-2.5.9t-2.6-.7l-.7-.4q-.4-.2-.4-.7.1-.3-.2-1h.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00493d",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M43.4 11.3q-.8-1-2.1-1v.2q1 .4 1.7 1.3zm-2.2-1c-.3-.4-1.1-.5-1.5-.4v.5l.6.6.6-.2zm-1.6-.4q-.6-.1-1 .1l-.1.6.4.1.6-.3V10Zm-2.3.5q.4-.5 1.2-.4l-.1.5-1.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00493d",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M42.8 11.8q-.6-.7-1.6-1.2v.3l.7 1.4zm-2.6.8v-1.4l.7-.2.8 1.4zM39 11l.5-.3q.4.1.6.5l-.2 1.5-1-.2zm-1.8.5V11q.7-.3 1.6 0v1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "m35.5 10.7-.3-.2h-.1v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M35.5 11.3c.4 0 .5-.5.7-.5m-.5.6c.3.1.6-.6.8-.6m-1.4-.3h.6m0 .5-.6.3m0-1.2q-.2 0-.3.3m-.1.2v.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.3 15.2v6.7c0 6-2.8 8-6.5 9.5-3.7-1.6-6.5-3.6-6.5-9.5v-6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M39.8 20.9q.5 0 1.2-.7.8-.9 2 0c.8.7 1.3.4 1.7 0q.6-.5 1.6-.5v-4.5h-13v4.5q1 0 1.5.5c.4.4 1 .7 1.7 0q1.4-.9 2 0 .8.6 1.3.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0b50a0",
    d: "M39.8 24.4c.4 0 1.2-.5 1.5-.6.7-.4 1.3 0 1.7.2q1 .4 2 0 .7-.6 1.2-.4l.1-1.7v-.4q-.6-.1-1.3.5t-1.8 0c-.8-.2-1.5-.8-2.2 0q-.5.6-1.2.7-.8-.1-1.2-.6c-.8-.9-1.5-.3-2.2 0q-1.1.5-1.9 0-.6-.8-1.2-.6v2.1q.5-.1 1.3.4c.5.4 1.5.2 2 0s1-.6 1.7-.2c.2.1 1 .6 1.5.6m0 1.5q1 0 1.7-.6 1-.4 1.9.2 1 .4 1.7 0 .2-.4.9-.3-.4 1.3-1 2.2a2 2 0 0 1-1.8-.1q-1.2-.7-2-.3t-1.4.5q-.6 0-1.3-.5-.9-.3-2.1.3a2 2 0 0 1-1.9.1l-.9-2.2q.7 0 .9.3a2 2 0 0 0 1.7 0q1-.6 1.9-.2.7.5 1.7.6m0 5.5a14 14 0 0 0 3.7-2.1l-.7-.2q-.5-.4-1.6 0a3 3 0 0 1-2.8 0q-1.2-.4-1.6 0l-.7.2q1.5 1.4 3.7 2.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9d050",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M38.9 16.9v.3q0 .2.2.2h.2l2.4-.3q1.1.1 1.6.3.5 0 .5-.4 0-.2-.9-.3l-2 .3q-1.4-.1-1.2-.6 0-.3.8-.4l.3-.1.4-.3 1-.2-.4.4q.5-.2.8.2h-.9q.1.2.4.3-.4.3-1 0h-.5l-.5.1q0 .3.8.3l2-.2c-.2 0 0-.2-.2-.3q.6 0 .9.4v-.7q.5.1.5.4l.2-.2.2.6.3-.3-.2.7q.4-.3.7 0l-.4.2q-.7.4-1.6.3l-1-.1 1 .4h.9q.3.3.5.2 0 .2-.2.3l.2.3h-.2q0 .2.2.3h-.2v.4q.2.3-.2.2 0 .2-.2.2l-.1-.2h-.2l-.1-.1q-.5 0-.3-.2 0-.2.3-.1h.2l.1-.2q0-.3-.6-.4-1 0-1.7-.3h-.1l-.2.3q0 .3.3.4-.2.3-.3 0l-.2.4v-.2q-.4.4-.6.3h-.8v.2h-.3v-.2h-.3v-.2h.1-.2V19h.2q.2-.2.4 0h.3q.4 0 .7-.3c-.6-.1-.3-.5-.1-.6H40q-1.2.7-2 .7v.2h-.3v.3l-.4-.2v.3h-.6l-.3.2v-.2l-.3.3v-.2l-.4.3v-.3l-.3.2v-.2q0 .2-.4.2h-.3q-.2 0 0-.1-.4 0-.3-.3v-.4h.2q.1-.4.4-.1 0 .3.4.2h.2l.9-.4v-.3l-.4.3v-.1H36l.1-.3h-.5l.2-.3h-.4l.1-.3H35l.3-.3q-.4 0-.5-.2h.3q-.2 0-.2-.4l-.2.2-.3-.1.1-.4-.1-.2.2-.1.1.1V16l.2-.1q.2 0 .2.2v.3l.1-.1q0-.2.3-.1v.6q.5.6 1 .7l.2-.4v-.2l.3-.3-.2-.5h.4l.2-.5v.3l.5-.3.1.3.6-.2-.1.2.4-.1-.2.4h.3l-.2.2h.4l-.1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M36.7 17.3q-.3.1-.3.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M36.7 17.5q-.5.3-.4.8m.6.3.5-.5m-.1.1-.1.5.3-.5m-.1.4.4-.5v.4l.2-.5v.2l.2-.3m0 .1v.2l.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M38.3 18q.3-.3.3-.7m0 .4.1-.5m-.4-1-.1.2-.2.2q0 .2-.2.2v-.2l.1-.3.1-.2q-.4.1-.4-.1m1 .3h-.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M38.1 16.5h.4q-.2 0-.1-.2m-.6-.1q-.2 0-.2.2h.3m-.3 1.5v-.1l.2-.1.3-.2.1-.3.2-.1.2-.1m-1.5-.3-.1.2v.3l-.1.2v.2m.4-1.5v.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "m37.4 16.6-.1.5q-.1.2.2.4.4.1.6-.5m.8 1.4-.1.1m.3-.3v.3M37 16v.1l-.1.2m-.1.3h-.1m0 .3h-.1m-1.6-.6v-.1m-.3.4h.1m-.2-.2h-.2m2.1 1.3-.4.7m.7-.5-.3.3m-1 .7h-.8v-.1m1.8-.3-.2.3q.5-.1.6-.7m-2.5 1h.3m5.8-1.1h.2l.3-.1m-3 .8q0-.2.3-.4m-1.6 1v-.2m-1.6.3v.2m-.5-.1.3-.2m4.6 0-.1.1m1 0q.3 0 .2-.2m-.6.2.3-.2m.7-.1V19m2.6.5v-.2l.2-.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M41.6 18.3c-.6-.3-.6-.6-1-.5m3.4 1.6v.1m.4-.1v.2m-2.7-3.5h-.3m-2.7 1.2.4.2m-.2-.6v-.3h-.2q-.1.3-.4.2 0 .2-.4.3l-.1-.3q-.3.1-.4 0v-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.1 18.2h-.3l.1.2.1.1.2.3v-.3q-.2-.2 0-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#073163",
    d: "M38 17q-.2 0-.2-.2h-.2q-.2.6-.5.7t0 .3q.5.1.8-.7m-3.5-.8v-.2l-.5.2zm.2-.6.3.1v.2h-.3zm.7.6q.2 0 .1-.2 0-.2-.3-.2c.2.1 0 .3.2.4m-1.3.5.3.2.1-.2q0-.2-.2 0zm.5 2.2q-.1-.3-.4 0h.2l.1.1zm.3-.2q-.1-.3-.4-.2l.2.2zm-.4.6q-.3 0-.3.4l.3-.2h.1zm0 .6q.2 0 .2-.2h.2v.3zm5-1q-.2-.2-.5 0h.2q0 .2.2 0m-.4.2-.4.2h.3zm.2.3-.3.2h.2zm.3.2-.2.1v.3l.2-.2zm4-.3h-.3v.4l.2-.1zm.1.2q-.1.1 0 .4v-.2q.3 0 .2-.2zm.4.1-.1.1.1.3.1-.2v-.2m.4 0q-.2 0-.1.2h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9d050",
    d: "m34.8 26 1.7-5.3 1.8 5.4-4.6-3.3h5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#024919",
    d: "m35.1 25.6 3.6-2.7h-4.4l3.6 2.7-1.4-4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9d050",
    d: "m41.3 26 1.8-5.3 1.7 5.4-4.6-3.3H46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#024919",
    d: "m41.7 25.6 3.6-2.7h-4.5l3.6 2.7-1.3-4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9d050",
    d: "m38 29.9 1.8-5.4 1.7 5.4-4.5-3.3h5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#024919",
    d: "m38.4 29.4 3.6-2.7h-4.4l3.5 2.7-1.3-4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M46.3 15.2v6.7c0 6-2.8 8-6.5 9.5-3.7-1.6-6.5-3.6-6.5-9.5v-6.8h13Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKy);
export default __webpack_public_path__ + "static/media/ky.48a20905bc5da2ba333aef7fab6cb919.svg";
export { ForwardRef as ReactComponent };